import { makeStyles } from 'tss-react/mui';

export default makeStyles()({
    title: {
        marginBottom: 24
    },
    filter: {
        marginBottom: 24
    }
});
